/*****
 * Created with vscode
 * Name : 悬浮框
 * Date : 2020/3/2
 * Author : Bevis Shen
 * Func :
 *  version: 版本
 ******/

<template>
  <div class="suspension-tips" v-if="version === 'fever'">
    <a href="javascript:;" class="suspension-tips-mess" @click="enterMessCenter">
      <i v-if="readMessage > 0" class="tips-unread">{{readMessage}}</i>
    </a>
    <a href="javascript:;" class="suspension-tips-doc" @click="enterMyDoctor"></a>
  </div>
</template>

<script>
import api from '@/config/api'
import { mapGetters } from 'vuex'

export default {
  name: 'SuspensionTips',
  props: {
    version: {
      type: String,
      default: 'fever'
    }
  },
  data () {
    return {
      readMessage: 0
    }
  },
  created () {
  },
  computed: {
    ...mapGetters([
      'token',
      'platId'
    ])
  },
  mounted () {
    // 查询未读消息
    if (this.$store.getters.token) {
      this.getNoReadMess()
    }
  },
  methods: {
    getNoReadMess () {
      // 获取未读消息
      this.$http.getNoReadMess({
      }, '医生数据加载中，数据较多，请耐心等待').then(res => {
        this.readMessage = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 跳转到登录页
    goUserReg () {
      this.$router.push({
        path: '/userReg',
        query: {
          platId: this.$route.query.platId
        }
      })
    },
    enterMessCenter () {
      if (this.$store.getters.token) {
        // 进入消息中心
        window.location.href = `${api.userBase}#/messageCenter?sessionId=${this.token}&platId=${this.platId || window.ServerConfig.platId}`
      } else {
        this.goUserReg()
      }
    },
    enterMyDoctor () {
      if (this.$store.getters.token) {
        // 进入我的医生
        window.location.href = `${api.userBase}#/doctor?sessionId=${this.token}&platId=${this.platId || window.ServerConfig.platId}`
      } else {
        this.goUserReg()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SuspensionTips.vue